<template>
    <modal height="auto" width="90%" :scrollable="true" @opened="onOpen" @closed="onHidden" name="client-task-add" classes="modal_default" :clickToClose="true">
    <div class="card" data-testid="client-task-add">
        <div class="card-header">
            Naplánovat úkol
        </div>
        <div class="card-body">
            <form @submit.prevent="postVisitTask(visit)">
                <div class="form-inline">
                    <label class="mr-sm-2" for="doctor">K doktorovi</label>
                    <select v-model="visit.planned_for" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" autofocus="autofocus" data-testid="client-task-add-doctor">
                        <option value="" disabled selected>zvolit doktora</option>
                        <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                    </select>
                    <small id="doctorHelp" class="form-text text-muted"></small>
                    <label for="operation" class="mr-sm-2">za účelem</label>
                    <select @change="visitPurposeChanged($event)" v-model="visit.purpose_id" class="form-control mr-sm-2" aria-describedby="operationHelp" id="visitPurposeSelect" data-testid="client-task-add-purpose">
                        <option v-for="visit_purpose in visit_purposes" :value="visit_purpose.id">{{ visit_purpose.purpose }}</option>
                    </select>
                    <select v-model="visit.visit_template_id" class="form-control mr-sm-2" aria-describedby="operationHelp" id="visitTemplateSelect" :disabled="visitTemplates === false" data-testid="client-task-add-template">
                        <option v-for="(visit_template, index) in visitTemplates" :value="visit_template.id" :selected="index === 0">{{ visit_template.name }}</option>
                        <option v-bind:value="false">bez šablony</option>
                    </select>
                    <label for="acute" class="mr-sm-2">
                        prioritní <input v-model="visit.acute" class="form-check-input" type="checkbox" id="acute" data-testid="client-task-add-priority">
                    </label>
                    <small id="operationHelp" class="form-text text-muted"></small>
                </div>

                <div class="form-inline mt-2">
                    <label for="note">poznámka: </label>
                    <input v-model="visit.note" type="text" class="form-control col-sm-9 ml-sm-1 mr-sm-2" aria-describedby="noteHelp" id="note" data-testid="client-task-add-note">

                    <button v-if="!visitPending" type="submit" class="btn btn-success" data-testid="client-task-add-submit">Přidat</button>
                    <button class="btn btn-success disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                </div>

            </form>
        </div>
    </div>
    </modal>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        // doctors: '',
        lastDuration: '',
        visit_purposes: '',
        visit: {
          client_id: null,
          planned_for: null,
          duration: 6, // TODO změnit ze settings ordinace (výchozí délka návštěvy)
          note: '',
          acute: false,
          purpose_id: '',
          visit_template_id: false,
          unplanned_visit: true
        },
        modalOpened: false,
        visitPurposeError: '',
        // new
        // visit
        visitPending: false,
        visitDone: false,
        visitError: false,
        // doctors
        doctors: false,
        doctorsPending: false,
        doctorsError: false,
        // visit templates
        visitTemplates: false
      }
    },
    props: ['opened'],
    mixins: [apiMixin],
    methods: {
      onHidden () {
        // this.opened = false
      },
      onOpen () {
        document.getElementById('doctor').focus()
      },
      visitPurposeChanged (event) {
        this.visit.duration = event.target.options[event.target.selectedIndex].getAttribute('data-duration')
        if (this.visit_purposes[event.target.selectedIndex].visit_task_templates.length > 0) {
          this.visitTemplates = this.visit_purposes[event.target.selectedIndex].visit_task_templates
          this.visit.visit_template_id = this.visitTemplates[0].id
        } else {
          this.visitTemplates = false
        }
      },
      initialSet () {
        this.visit = {
          client_id: null,
          planned_for: null,
          duration: 6, // TODO změnit ze settings ordinace (výchozí délka návštěvy)
          note: '',
          acute: false,
          purpose_id: '',
          unplanned_visit: true,
          visit_template_id: false
        }
      },
      getVisitPurposes () {
        this.waitForResponse = true
        this.$http.get('visit_task_purpose').then(response => {
          this.visit_purposes = response.data
          let visit = this.visit
          this.visit_purposes.forEach(function (visitPurpose) {
            if (visitPurpose.default === true) {
              visit.purpose_id = visitPurpose.id
            }
          })
          this.waitForResponse = false
        }).catch(error => {
          this.visitPurposeError = error.response.data.errors
          this.waitForResponse = false
        })
      },
      init () {
        this.initialSet()
        this.visit.client_id = this.$route.params.clientid
        this.getDoctors()
        this.getVisitPurposes()
      }
    },
    watch: {
      opened (val) {
        if (val === true) {
          this.init()
        }
      },
      visitDone (val) {
        if (val === true) {
          this.$emit('update')
          this.visitDone = false
          this.initialSet()
          this.visit.client_id = this.$route.params.clientid
          this.$modal.hide('client-task-add')
        }
      },
      '$route' (to, from) {
        if (to.params.clientid !== from.params.clientid && typeof (to.params.clientid) !== 'undefined') {
          this.init()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>



// WEBPACK FOOTER //
// src/views/Client/modals/AddTask.vue?341edba2